export class GlobalHelperFunctions {
  static createUrlQueryString(aParams: object, unEncoded: object, esc = encodeURIComponent): string {
    var query = Object.keys(aParams)
      .map(function (k) {
        return `${esc(k)}=${esc(aParams[k])}`;
      })
      .join('&');
    if (unEncoded) {
      query +=
        '&' +
        Object.keys(unEncoded)
          .map(function (k) {
            return `${k}=${unEncoded[k]}`;
          })
          .join('&');
    }
    return query;
  }
  static generateTimeFromSeconds(seconds: number, startWithMins: boolean = false): string {
    var date = new Date(null);
    date.setSeconds(seconds);
    if (startWithMins) {
      return date.toISOString().substr(14, 6);
    }
    return date.toISOString().substr(11, 8);
  }

  static generateHumanFileSize(aNum: number): string {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    let l = 0,
      n = parseInt(aNum, 10) || 0;

    // i'm using decimal places here instead of binary places for legibility
    while (n >= 1000 && ++l) {
      n = n / 1000;
    }

    return n.toFixed(n < 100 && l > 0 ? 2 : 0) + ' ' + units[l];
  }

  static setupDragDrop(dmElem, aDragEndCallback: () => {}): void {
    dmElem.addEventListener('dragstart', this.drag_start, false);
    $(dmElem).attr('draggable', true);
    document.body.addEventListener('dragover', this.drag_over, false);
    document.body.addEventListener(
      'dragend',
      () => {
        aDragEndCallback();
      },
      false,
    );
    document.body.addEventListener(
      'drop',
      event => {
        this.drop(event, dmElem);
      },
      false,
    );
  }

  static removeDragDrop(dmElem): void {
    dmElem.removeEventListener('dragstart', this.drag_start, false);
    $(dmElem).attr('draggable', false);
    document.body.removeEventListener('dragover', this.drag_over, false);
    document.body.removeEventListener(
      'drop',
      event => {
        this.drop(event, dmElem);
      },
      false,
    );
  }

  static drag_start(event) {
    var style = window.getComputedStyle(event.target, null);
    event.dataTransfer.setData(
      'text/plain',
      parseInt(style.getPropertyValue('left'), 10) -
        event.clientX +
        ',' +
        (parseInt(style.getPropertyValue('top'), 10) - event.clientY) +
        ',' +
        event.target.getAttribute('data-item'),
    );
  }

  static drop(event, dmElem) {
    event.preventDefault();
    var offset = event.dataTransfer.getData('text/plain').split(',');
    dmElem.style.left = event.clientX + parseInt(offset[0], 10) + 'px';
    dmElem.style.top = event.clientY + parseInt(offset[1], 10) + 'px';
    return false;
  }

  static drag_over(event) {
    event.preventDefault();
    return false;
  }

  static formatPlace(placeNumber: number): string {
    if (!placeNumber) {
      return '';
    }
    const place = placeNumber.toString();
    if (placeNumber > 3 && placeNumber < 21) return place + 'th';
    switch (placeNumber % 10) {
      case 1:
        return place + 'st';
      case 2:
        return place + 'nd';
      case 3:
        return place + 'rd';
      default:
        return place + 'th';
    }
  }
}
